import { render, staticRenderFns } from "./TipoProductoForm.vue?vue&type=template&id=76788c89&"
import script from "./TipoProductoForm.vue?vue&type=script&lang=js&"
export * from "./TipoProductoForm.vue?vue&type=script&lang=js&"
import style0 from "./TipoProductoForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports